import styled from 'styled-components'
import { DARK_VIOLET, NEUTRAL_100, PALE_BLUE, WHITE } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const Container = (styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 12px;
  color: black;
  cursor: pointer;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const HeaderContainer = (styled.div<{ $isExpanded: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom-left-radius: ${({ $isExpanded }) => ($isExpanded ? '0px' : '12px')};
  border-bottom-right-radius: ${({ $isExpanded }) => ($isExpanded ? '0px' : '12px')};
  border-bottom: ${({ $isExpanded }) => ($isExpanded ? `1px solid ${NEUTRAL_100}` : '0px')};
  padding: 16px;
  background-color: ${PALE_BLUE};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Title = (styled.span`
  font-family: ${INTER.medium};
  color: ${DARK_VIOLET};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const ChevronContainer = (styled.div``) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const StepsContainer = (styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const StepRowContainer = (styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const StepNumberContainer = (styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  aspect-ratio: 1;
  border-radius: 100%;
  position: relative;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const StepNumber = (styled.span`
  z-index: 4;
  color: ${WHITE};
  font-family: ${INTER.semiBold};
  font-size: 12px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const StepNumberBackground = (styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 24px;
  height: 24px;
  aspect-ratio: 1;
  border-radius: 100%;
  background: linear-gradient(135deg, #87CEEB, #9370DB);
  z-index: 3;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const StepNumberOuterBackground = (styled.div`
  position: absolute;
  width: 40px;
  height: 40px;
  aspect-ratio: 1;
  border-radius: 100%;
  background: white;
  z-index: 2;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const StepConnectorDown = (styled.div`
  position: absolute;
  top: 12px;
  width: 3px;
  height: 250%;
  background: linear-gradient(90deg, #87CEEB, #9370DB);
  z-index: 1;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const StepConnectorUp = (styled.div`
  position: absolute;
  bottom: 12px;
  width: 3px;
  height: 250%;
  background: linear-gradient(90deg, #87CEEB, #9370DB);
  z-index: 1;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const StepTextContainer = (styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const StepText = (styled.span`
  font-family: ${INTER.regular};
  font-size: 13px;
  color: ${DARK_VIOLET};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const StepDivider = (styled.div`
  width: 100%;
  height: 1px;
  background-color: ${NEUTRAL_100};
  margin: 16px 0px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
